import {Text, View} from '@/components/react-native';
import {INoteInfo} from '@/types/airport';
import moment from 'moment';

interface NoteDetailContentProps {
  item: INoteInfo;
}

const CircleIcon = () => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
    <path d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0z" fill="#C4B5FD" />
  </svg>
);

export const NoteDetailContent = ({item}: NoteDetailContentProps) => {
  return (
    <View className="flex-col gap-[8px] px-0 py-[16px] w-full">
      {/* Content */}
      <View className="flex-row gap-[16px] items-start px-[16px]">
        <Text
          fontFamily="Geist"
          className="text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px] leading-[24px]"
        >
          {item.content}
        </Text>
      </View>

      {/* Metadata */}
      <View className="flex-col gap-[6px] px-[16px] py-[8px]">
        <Text
          fontFamily="Geist"
          className="text-[#78716C] text-[14px] font-[400] tracking-[-0.28px] leading-[14px]"
        >
          Shared by{' '}
          <span className="text-[#38BDF8] font-[500] tracking-[-0.32px]">
            {item.created_by}{' '}
          </span>
          at {moment(item.created_at).format('DD/MM/YY HH:mm')}
        </Text>
        {item?.created_by !== 'Admin' && item?.approved_by && (
          <Text
            fontFamily="Geist"
            className="text-[#78716C] text-[14px] font-[400] tracking-[-0.28px] leading-[14px]"
          >
            Approved by {item.approved_by} at{' '}
            {moment(item.approved_at).format('DD/MM/YY HH:mm')}
          </Text>
        )}
      </View>
    </View>
  );
};
